
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_urfz4_17",
  "disabled": "awsui_disabled_1p2cx_urfz4_54",
  "parent": "awsui_parent_1p2cx_urfz4_57",
  "highlighted": "awsui_highlighted_1p2cx_urfz4_60",
  "in-trigger": "awsui_in-trigger_1p2cx_urfz4_63",
  "content": "awsui_content_1p2cx_urfz4_70",
  "label-content": "awsui_label-content_1p2cx_urfz4_77",
  "label": "awsui_label_1p2cx_urfz4_77",
  "tag": "awsui_tag_1p2cx_urfz4_84",
  "label-tag": "awsui_label-tag_1p2cx_urfz4_85",
  "label-prefix": "awsui_label-prefix_1p2cx_urfz4_95",
  "single-line": "awsui_single-line_1p2cx_urfz4_108",
  "tags": "awsui_tags_1p2cx_urfz4_127",
  "description": "awsui_description_1p2cx_urfz4_128",
  "selected": "awsui_selected_1p2cx_urfz4_139",
  "icon": "awsui_icon_1p2cx_urfz4_153",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_urfz4_160",
  "trigger-variant": "awsui_trigger-variant_1p2cx_urfz4_175",
  "custom-content": "awsui_custom-content_1p2cx_urfz4_181"
};
  